import { ShieldCheck, EyeOff } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ChapterLabel } from "@/components/ChapterLabel";

const normas = [
  "Respeto absoluto entre miembros.",
  "Confidencialidad: lo compartido dentro no se difunde fuera.",
  "Prohibido hacer capturas o reenviar mensajes sin consentimiento.",
  "Nada de acoso, ataques personales, discriminación o spam.",
  "La comunidad no sustituye atención médica, psicológica ni de emergencia.",
  "La administración puede retirar el acceso por incumplimiento grave de las normas.",
];

export const Normas = () => (
  <section id="normas" className="bg-[#0B1120] px-5 py-24 md:py-32">
    <div className="mx-auto max-w-[1100px]">
      <Reveal>
        <ChapterLabel number="06" testId="chapter-normas" />
        <h2 className="max-w-3xl text-3xl font-semibold tracking-tight text-[#F5F1EA] md:text-5xl">
          Normas para cuidar el espacio
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2" data-testid="normas-list">
        {normas.map((norma, i) => (
          <Reveal key={norma} delay={0.04 * i}>
            <div className="flex items-start gap-4 rounded-2xl border border-[#22304D] bg-[#131D33] p-5">
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#8B7CF6]/10 text-[#8B7CF6]">
                <ShieldCheck className="h-4 w-4" strokeWidth={1.5} />
              </span>
              <p className="text-sm leading-relaxed text-[#E8E4DC] md:text-base">
                {norma}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div
          data-testid="normas-whatsapp-privacy"
          className="mt-8 flex items-start gap-4 rounded-2xl border border-amber-400/20 bg-amber-400/5 p-6"
        >
          <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-400/10 text-amber-400">
            <EyeOff className="h-4 w-4" strokeWidth={1.5} />
          </span>
          <p className="text-sm leading-relaxed text-amber-200/90 md:text-base">
            Una nota honesta sobre privacidad: la conversación ocurre en
            WhatsApp. Dependiendo de la configuración y las funciones de la
            aplicación, otros miembros pueden ver tu nombre, tu fotografía o tu
            número. Antes de entrar, revisa la información de privacidad y
            configura tu perfil como prefieras.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
